import { BaseService } from './base.service';

export interface PaymentIntentItem {
  productId: string;
  quantity: number;
}

export interface PaymentIntentBooking {
  bookingTypeId: string;
  slotCount: number;
}

export interface CreatePaymentIntentRequest {
  amount: number;
  currency: string;
  memberId: string;
  locationId: string;
  /* Shop purchases only. Ids and quantities, not names or prices —
     the API reads those from the catalog so what Stripe records
     cannot be dictated by the browser. */
  items?: PaymentIntentItem[];
  /* Drop-in bookings only. The booking type id and how many slots are
     being charged — the API turns that into the wording Stripe shows. */
  booking?: PaymentIntentBooking;
  /* For charges that are neither a cart nor a booking. Without it the
     $1 card-validation charge lands in Box OS's transaction log as an
     untyped "Other" row that reads as unexplained revenue. */
  purpose?: 'card_update';
}

export interface CreatePaymentIntentResponse {
  clientSecret: string;
  externalPaymentId: string;
  publishableKey: string;
}

export interface PaymentMethod {
  id: string;
  brand?: string;
  last4?: string;
  expMonth?: number;
  expYear?: number;
}

export interface GetPaymentMethodsResponse {
  paymentMethods: PaymentMethod[];
}

class StripeServiceClass extends BaseService {
  constructor() {
    super('/stripe/payments');
  }

  async createPaymentIntent(
    data: CreatePaymentIntentRequest
  ): Promise<CreatePaymentIntentResponse> {
    return this.post<CreatePaymentIntentResponse>('/create-payment-intent', data);
  }

  async getPaymentMethods(
    memberId: string,
    locationId: string
  ): Promise<GetPaymentMethodsResponse> {
    return this.get<GetPaymentMethodsResponse>(
      `/payment-methods?memberId=${memberId}&locationId=${locationId}`
    );
  }

  async checkConfiguration(locationId: string): Promise<{ isConfigured: boolean }> {
    return this.get<{ isConfigured: boolean }>(
      `/check-configuration?locationId=${locationId}`
    );
  }
}

export const StripeService = new StripeServiceClass();
